export default __webpack_public_path__ + "static/media/img_major03_sub2.e58e1091.png";